/**
 * PendingInvitations Component - Shows collaboration invitations
 */
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';

export const PendingInvitations = ({ 
  invitations, 
  userId, 
  onRespond 
}) => {
  if (invitations.length === 0) return null;
  
  return (
    <Card className="border-yellow-500 bg-yellow-500/10">
      <CardContent className="py-4">
        <div className="flex items-center gap-2 mb-3">
          <Users className="w-5 h-5 text-yellow-500" />
          <span className="font-medium text-yellow-500">
            You have {invitations.length} collaboration invitation(s)
          </span>
        </div>
        {invitations.map(workshop => {
          const invite = workshop.collaborators.find(
            c => c.user_id === userId && c.status === 'pending'
          );
          return (
            <div 
              key={workshop.id} 
              className="flex items-center justify-between py-2 border-t border-yellow-500/30"
            >
              <div>
                <p className="font-medium">{workshop.title}</p>
                <p className="text-sm text-gray-400">
                  Offered {invite?.income_percentage}% income share
                </p>
              </div>
              <div className="flex gap-2">
                <Button 
                  size="sm" 
                  variant="outline"
                  onClick={() => onRespond(workshop.id, 'rejected')}
                >
                  Decline
                </Button>
                <Button 
                  size="sm"
                  onClick={() => onRespond(workshop.id, 'accepted')}
                  className="bg-green-600 hover:bg-green-700"
                >
                  Accept
                </Button>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
